import './testimonials.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleUser,
  faQuoteLeft,
} from '@fortawesome/free-solid-svg-icons';
function Testimonials() {
  return (
    <div id="testimonial-container">
      <div id="testimonial-section">
        <div className="row" id="section-container">
          <div id="testimonial-section-1">
            <div id="from-community">
              <p id="from-community-caption">From our community</p>
              <p id="people-saying">Here's what people are saying about IYNS Research Foundation</p>
              <div id="left-right-butttons">
                <FontAwesomeIcon icon={faCircleArrowLeft} id="left-arrow" />
                <FontAwesomeIcon icon={faCircleArrowRight} id="right-arrow" />
              </div>
            </div>
          </div>
          <div id="testimonial-section-2">
            <div id="testimonial-statements">
              <div>
                <FontAwesomeIcon icon={faQuoteLeft} id="quotes" />
              </div>
              <div id="statement">
                <p>
                  IYNS is a great platform to learn about nuclear science and be part of India's
                  clean energy future."
                </p>
              </div>
              <div>
                <div>
                  <div id="user-icon">
                    <FontAwesomeIcon icon={faCircleUser} id="user" />
                  </div>
                  <div id="name">
                    <p id="kyle">Naman</p>
                    <p id="advisor">Advisor</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
